import { withFormik } from 'formik';
import { updatePassword } from '../../../facades/eagle/user';
import compose from 'recompose/compose';
import withProps from 'recompose/withProps';
import omit from 'lodash/omit';
import withQueryParams from '../../hocs/withQueryParams';
import { replaceRichText } from 'src/common/utils/text-replace';
import { localiseUrl } from 'src/common/utils/format-localised-url';
import { withUser } from '../../data-providers/user';

/* eslint-disable no-console */
const withUpdatePassword = compose(
  withQueryParams,
  withUser,
  withProps(props => ({
    formDescription: replaceRichText(props.formDescription, {
      name: props.user.firstname
    }),
  })),
  withFormik({
    mapPropsToValues: ({ queryParams }) => ({
      base: '',
      confirmation_token: queryParams.confirmation_token || null,
      password: '',
      password_confirmation: '',
    }),
    handleSubmit: (values, actions) => {
      values = omit(values, ['base']);
      const props = actions.props;
      updatePassword(values)
        .then(() => window.location = localiseUrl(props.country, '/account'))
        .catch(err => {
          actions.setSubmitting(false);
          const errors = err.details.errors;
          switch (err.status) {
            case 401:
              actions.setFieldError('base', errors[0].detail);
          }
        });
    },
  }),
);
/* eslint-enable no-console */

export default withUpdatePassword;



// WEBPACK FOOTER //
// ./src/client/js/view/components/UserForm/withUpdatePassword.js